jQuery(document).ready(function(){
  
 var accordions = document.getElementsByClassName("accordion");
 
for (let i = 0; i < accordions.length; i++) {
   accordions[i].addEventListener("click", function () {
      // Close all other open accordions
      for (let j = 0; j < accordions.length; j++) {
         if (accordions[j] !== this) {
            accordions[j].classList.remove("active");
            accordions[j].nextElementSibling.style.maxHeight = null;
            accordions[j].querySelector(".icon").textContent = "+";
         }
      }
 
      // Toggle the current accordion
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
         panel.style.maxHeight = null;
         this.querySelector(".icon").textContent = "+";
      } else {
         panel.style.maxHeight = panel.scrollHeight + "px";
         this.querySelector(".icon").textContent = "-";
      }
   });
}
  
});
